export default function ContactSection() {
  return (
    <footer className="relative w-full bg-foreground-950 text-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          <div className="w-full lg:w-2/5 space-y-8">
            <div className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center">
              <i className="ri-building-2-line text-xl text-white/70"></i>
            </div>
            <p className="text-base md:text-lg text-white/60 leading-relaxed max-w-sm">
              Professional engineering team based in Vilnius, Lithuania, delivering modern software solutions for the iOS platform.
            </p>
          </div>
          <div className="w-full lg:w-3/5">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-12">
              <div className="space-y-3">
                <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 font-semibold">
                  Address
                </h4>
                <address className="not-italic space-y-1">
                  <p className="text-sm md:text-base text-white/80 leading-relaxed">
                    Eitminu g. 12-22
                  </p>
                  <p className="text-sm md:text-base text-white/80 leading-relaxed">
                    Vilnius, 08221
                  </p>
                  <p className="text-sm md:text-base text-white/80 leading-relaxed">
                    Lithuania
                  </p>
                </address>
              </div>
              <div className="space-y-3">
                <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 font-semibold">
                  Phone
                </h4>
                <p className="text-sm md:text-base text-white/80 leading-relaxed">
                  +370 66806220
                </p>
              </div>
              <div className="space-y-3">
                <h4 className="text-xs uppercase tracking-[0.25em] text-white/40 font-semibold">
                  Email
                </h4>
                <p className="text-sm md:text-base text-white/80 leading-relaxed break-all">
                  co@dirbtuviucentrasit.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs md:text-sm text-white/40">
            &copy; {new Date().getFullYear()} DIRBTUVIU CENTRAS, IT. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}